export default __webpack_public_path__ + "static/media/optimal-body.2ccecf47.png";